import React from 'react'
import MainContent from '../../components/MainContent/MainContent'
import AppShell from '../AppShell/AppShell'
import Index from '../../components/Dashboard/Index'

const Overview = () => {
  return (
    <>
      <AppShell route="transactions">
        <MainContent>
          <Index></Index>
        </MainContent>
      </AppShell>
    </>
  )
}

export default Overview